module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "h4 d-flex",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.navigateToDashboard
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "color": "#C6CCD0"
    }
  }, [_vm._v("mdi-view-dashboard")]), _vm._v(" "), _c('div', {
    staticClass: "text-button pl-1"
  }, [_vm._v("Dashboard")])], 1)]), _vm._v(" "), _c('v-card-title', {
    staticClass: "justify-center",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("Lake5 Metadata")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "justify-center"
  }, [_c('iframe', {
    attrs: {
      "width": "2200",
      "height": "1000",
      "src": _vm.iframeSrc,
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c6e5f96","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/chartDashboard/QuickSightDashboard.vue
// module id = 2054
// module chunks = 0